import React from 'react';
import './BrandSlider.css';

import flipkartLogo from '../../assets/flipkart.png';
import elasticrunLogo from '../../assets/elsticrun.png';
import easyshipLogo from '../../assets/easyship.png';
import amazon from '../../assets/amazon.png';
import bigbasket from '../../assets/bigbasket.png'


const brands = [
    { src: flipkartLogo, alt: 'Flipkart' },
    { src: elasticrunLogo, alt: 'ElasticRun' },
    { src: easyshipLogo, alt: 'EasyShip' },
    { src: amazon, alt: 'Amazon' },
    { src: bigbasket, alt: 'BigBasket' },

];

const BrandSlider = () => {
    return (
        <div className="brand-slider-wrapper">
            <div className="brandHeader">
                <h2>Our Trusted Partners</h2>
                <p>We are proud to partner with leading brands in the industry.</p>
            </div>
            <div className="brand-track">
                {[...brands, ...brands].map((brand, index) => (
                    <img key={index} src={brand.src} alt={brand.alt} />
                ))}
            </div>
        </div>
    );
};


export default BrandSlider;
